import { useTranslation } from "react-i18next";
import qr from "@/assets/appstore-qr-home_clarity.svg";

/** Desktop-only "Scan to install" card for the Clarity home (QR tagged ct=home_clarity). Hidden below lg (phones install with the buttons). */
const QrCard = ({ bordered = true }: { bordered?: boolean }) => {
  const { t } = useTranslation();
  return (
    <div
      className={`hidden items-center gap-3 rounded-2xl bg-white py-1.5 pe-4 ps-1.5 text-start lg:inline-flex ${
        bordered ? "border border-foreground/10" : ""
      }`}
    >
      <img
        src={qr}
        alt={t("home.qr.alt")}
        width={60}
        height={60}
        loading="lazy"
        decoding="async"
        className="block h-[60px] w-[60px] rounded-lg"
      />
      <span className="text-[13px] leading-[1.35] text-pf-ink2">
        <b className="block font-semibold text-foreground">{t("home.qr.title")}</b>
        {t("home.qr.body")}
      </span>
    </div>
  );
};

export default QrCard;
